import React from 'react';
const TextArea = (props) => {
    return (React.createElement("div", { key: props.key, className: `flex flex-col mb-[1rem] ${props.className ?? ''}`, style: {
            marginBottom: '15px',
            ...props.style,
        } },
        props.label && (React.createElement("label", { className: "form-label", htmlFor: props.id },
            props.label,
            " ",
            props.required && '*')),
        React.createElement("textarea", { id: props.id, name: props.name, value: props.value, defaultValue: props.defaultValue, placeholder: props.placeholder, required: props.required, disabled: props.disabled ?? false, rows: props.rows ?? 5, cols: props.cols ?? 50, onChange: props.onChange, onInput: props.onInput, style: { resize: 'none', width: '100%', border: '1px solid #ddd', borderRadius: '0px' } })));
};
export default TextArea;
